import useIsFirstRender from 'common/hooks/useIsFirstRender';
import type { ComponentWithChildren } from 'common/types/helpers';
import type { AppProps } from 'next/app';
import Head from 'next/head';

import 'styles/styles.scss';

export const APP_NAME = 'PolyAI Studio';

const NullFirstRender: ComponentWithChildren = ({ children }) => {
  const isFirstRender = useIsFirstRender();

  if (isFirstRender) {
    return null;
  }

  return <>{children}</>;
};

const SafeHydrate: ComponentWithChildren = ({ children }) => {
  return (
    <div suppressHydrationWarning={true}>
      {typeof window !== 'undefined' && (
        <NullFirstRender>{children}</NullFirstRender>
      )}
    </div>
  );
};

export default function PortalApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <title>{APP_NAME}</title>
        <meta
          content="width=device-width, initial-scale=1, maximum-scale=1"
          name="viewport"
        />
      </Head>
      <SafeHydrate>
        <Component {...pageProps} />
      </SafeHydrate>
    </>
  );
}
